var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 4,
    fill: "#D98EE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 9.05876H20.7499V8H19.6875V9.05876H13.3125V8H12.2501V9.05876H10.125C9.56154 9.05876 9.02099 9.28193 8.62238 9.67899C8.22394 10.0762 8 10.6149 8 11.1765V23.8823C8 24.4439 8.22394 24.9825 8.62238 25.3798C9.02099 25.7768 9.56154 26 10.125 26H22.875C23.4385 26 23.979 25.7768 24.3776 25.3798C24.7761 24.9825 25 24.4439 25 23.8823V11.1765C25 10.6149 24.7761 10.0762 24.3776 9.67899C23.979 9.28193 23.4385 9.05876 22.875 9.05876ZM16.5 22.8237C15.0911 22.8237 13.7398 22.2659 12.7435 21.2731C11.7472 20.2802 11.1875 18.9336 11.1875 17.5296C11.1875 16.1255 11.7472 14.7789 12.7435 13.7861C13.7398 12.7932 15.0911 12.2354 16.5 12.2354C17.9089 12.2354 19.2602 12.7932 20.2565 13.7861C21.2528 14.7789 21.8125 16.1255 21.8125 17.5296C21.8125 18.9336 21.2528 20.2802 20.2565 21.2731C19.2602 22.2659 17.9089 22.8237 16.5 22.8237Z",
    fill: "#F8F5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5281 16.1099L16.879 18.0676L13.5082 19.9906L13.5281 16.1099Z",
    fill: "#F8F5F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 1,
    height: 4,
    fill: "#F8F5F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4);
export default __webpack_public_path__ + "static/media/g4.04c584043dd5017c770385806768fd42.svg";
export { ForwardRef as ReactComponent };